module.exports = __webpack_public_path__ + "img/j1.b994cdb2.jpeg";